




import {Component, Prop, Vue} from "vue-property-decorator"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import {format, parse} from "date-fns"
import * as links from "@/data/sources/auditLinks"
import {executeQuery} from "@/data/repos/query"

@Component({
    components: {
      DataGrid,
    },
  })
  export default class AuditMostCommonNoAccessReasonsDrillDown extends Vue {
    @Prop() public args!: {
      fromDate: string,
      toDate: string,
      reasonId: number,
      categoryId: number,
    }
    public tableData: object[] = []
    public fields = [
      {name: 'regionName', title: 'Region', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportRegion},
      {name: 'siteName', title: 'Site', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportSite},
      {name: 'buildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportBuilding},
      {name: 'floorName', title: 'Floor', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportFloor},
      {name: 'roomName', title: 'Room', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportRoom},
      {name: 'releaseDate', title: 'Release Date', dataType: DataType.Date, sort: 1},
      {name: 'functionalArea', title: 'Functional Area', dataType: DataType.Text, sort: 1},
      {name: 'team', title: 'Team', dataType: DataType.Text, sort: 1},
    ]

    public getData(offset = 0, limit = 200) {
      /*
        @locale AT_Locale, @fromDate smalldatetime, @toDate smalldatetime,
        @auditTemplateID bigint = 0, @riskID AS bigint = 0, @functionalAreaID bigint = 0, @auditPurposeID bigint = 0, @teamID bigint = 0,
        @responsibleGroupID bigint = 0, @departmentID bigint = 0, @elementTypeID bigint = 0,
        @reasonId int
       */
      // Out: {"auditID":10686, "roomID":32600, "releaseDate":"2018-12-07T00:00:00.000+0000", "functionalarea":"Ground Floor General Admin", "team":"Team Tim",
      // "Location":"|OCS, OCS|OCS|OCS/CNWL Northwick Park Hospital Site|Level 0, L0|Room 004  ADL Kitchen - S14, Room 004"}
      return executeQuery(
        "micad4-audit", "mostCommonNoAccessReasons_Grid",
        {locale: "en-GB", fromDate: this.args.fromDate, toDate: this.args.toDate, reasonID: this.args.reasonId, categoryID: this.args.categoryId},
        this.filter, offset, limit)
    }

    private filter(data: any[]): any[] {
      return data.map(item => {
        const locations = item.Location.split("|")
        return {
          auditID: item.auditID,
          regionName: locations[1],
          siteName: locations[2],
          buildingName: locations[3],
          floorName: locations[4],
          roomName: locations[5],
          releaseDate: format(parse(item.releaseDate.substr(0, 10), "yyyy-MM-dd", 0), 'dd/MM/yyyy'),
          functionalArea: item.functionalarea,
          team: item.team,
          categoryId: this.args.categoryId,
        }
      })
    }
  }
